/**
 * Асинхронная операция без параллельных запусков: вызов во время выполнения
 * не стартует вторую копию, а запоминается (последний аргумент) и
 * выполняется после текущей. Нужна для сброса совместного документа: второй
 * invalidate, пришедший во время переинициализации, иначе запускал бы вторую
 * параллельно — два провайдера, два документа, гонка за локальную копию.
 */
export function serialLatest<T>(
  run: (arg: T) => Promise<void>,
  isDisposed: () => boolean = () => false,
): (arg: T) => Promise<void> {
  let running = false
  let pending: { arg: T } | null = null
  return async (arg: T) => {
    if (isDisposed()) return
    if (running) {
      pending = { arg }
      return
    }
    running = true
    try {
      let next: { arg: T } | null = { arg }
      while (next && !isDisposed()) {
        pending = null
        await run(next.arg)
        next = pending
      }
    } finally {
      running = false
      pending = null
    }
  }
}
